/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForJiraDatacenter extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForJiraDatacenter");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForJiraDatacenter.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForJiraDatacenter>): ServiceAccountCredentialsForJiraDatacenter {
        let obj = Object.assign(new ServiceAccountCredentialsForJiraDatacenter(), model);
        ServiceAccountCredentialsForJiraDatacenter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForJiraDatacenter>): ServiceAccountCredentialsForJiraDatacenter {
        if (!model) return null;
        return ServiceAccountCredentialsForJiraDatacenter.newInstance(<ServiceAccountCredentialsForJiraDatacenter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForJiraDatacenter) {
        if (!obj) return;

        models.ServiceAccountCredentialsForJiraDatacenter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForJiraDatacenter): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForJiraDatacenter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
